import React from 'react'
import {BlockSpacer} from '../../../../styledComponents/ResponsiveConvenience'
import {
    createResidentWithErrorHandlingPage,
    ResidentWithErrorHandlingPagePropsSet
} from '../../../../components/shared/hoc/createResidentWithErrorHandlingPage'
import {Box} from '@mui/material';
import {ColumnFlexContainer} from '../../../../styledComponents/FlexComponents'
import styled from 'styled-components'
import {Colors, FontSize, FontWeights} from '../../../../styledComponents/Constants'
import {Location} from 'react-router-dom'
import {NatResidentStepper} from '../../common/resident/NatResidentStepper'
import {BreakPcOnly} from '../../../../styledComponents/DisplayItem'

interface Props {
    location: Location
}

const NatResidentUserRegistrationCompletePage: React.FC<Props & ResidentWithErrorHandlingPagePropsSet> = props => {

    return (<>
            <BlockSpacer height={'30px'}/>
            <NatResidentStepper
                stepList={[
                    {label: '手続き説明'},
                    {label: <>マンション・<BreakPcOnly/>メールアドレス登録</>},
                    {label: 'メール受信'},
                    {label: '申請者情報登録'},
                    {label: '申請者情報確認'},
                    {label: '申請提出完了', isActive: true, isSquare: true}
                ]}
            />
            <ColumnFlexContainer>
                <BlockSpacer height={'60px'}/>
                <img src={'/resources/images/icons/icon_reserve_complete.svg'} width={'120px'} alt={'complete'}/>
                <BlockSpacer height={'20px'}/>
                <CompleteMessage>申請を提出しました</CompleteMessage>
                <Box height={'5px'}/>
                <CompleteMessageSub>管理会社にて申請内容を確認後、メールにて結果をお知らせします。<br/>
                    確認には数日お時間をいただきます。</CompleteMessageSub>
                <Box height={'5px'}/>
                <ContactMessageBox>
                    <ContactMessageTitle>ユーザ登録はまだ完了しておりません</ContactMessageTitle>
                    申請結果のメールからユーザ登録をお願いします。
                </ContactMessageBox>
            </ColumnFlexContainer>
        </>
    )
}

export default createResidentWithErrorHandlingPage(NatResidentUserRegistrationCompletePage)

const CompleteMessage = styled.div`
    font-size: ${FontSize.Big};
    font-weight: ${FontWeights.Bold};
    color: ${Colors.AccentDark};
`
const CompleteMessageSub = styled.div`
    font-size: ${FontSize.Small};
    text-align: center;
`
const ContactMessageBox = styled.div`
    font-size: ${FontSize.Middle};
    width: 350px;
    border: 1px solid #F5A623;
    padding: 8px;
    margin: 10px 0 10px 0;
    background-color: #F5A62333;
`
const ContactMessageTitle = styled.div`
    margin-bottom: 10px;
    font-weight: ${FontWeights.Bold};
`
